import { Card, CardContent } from "@/components/ui/card";
import { Landmark } from "lucide-react";
import { inr, inrShort } from "@/pages/Dashboard";

export const GSTR2BankCharges = ({ bank, onDrill }) => {
  if (!bank || !bank.count) return null;
  return (
    <Card className="border-amber-200 bg-amber-50/40 shadow-sm fade-in-up" data-testid="gstr2-bank-charges">
      <CardContent className="p-4">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <button type="button" onClick={() => onDrill({ metric: "bank" })} className="text-left group" data-testid="gstr2-bank-drill-btn">
            <p className="text-sm font-semibold text-amber-900 flex items-center gap-2"><Landmark className="h-4 w-4" /> Bank Charges (direct GL) — included in Eligible ITC</p>
            <p className="text-[11px] text-amber-800/80 max-w-3xl">Entries posted straight to the Input-GST ledger without a vendor (bank charges, petty-cash expenses). Posting-date basis — ties to SAP's GSTR2 BANK CHARGES query. Includes direct-GL RCM expenses (typed 'RCM (input credit)' in the chips above). Click to see the lines.</p>
          </button>
          <div className="grid grid-cols-3 md:grid-cols-5 gap-3 text-right">
            {[["Lines", bank.count, "count"], ["Taxable", inrShort(bank.taxable_value), "taxable"], ["IGST", inr(bank.igst), "igst"], ["CGST + SGST", inr(bank.cgst + bank.sgst), "cgst-sgst"], ["Total tax", inr(bank.total_tax), "total"]].map(([l, v, id]) => (
              <div key={id}>
                <div className="text-[10px] uppercase tracking-wider text-slate-500">{l}</div>
                <div className="text-sm font-semibold tabular-nums text-slate-900" data-testid={`gstr2-bank-${id}`}>{v}</div>
              </div>
            ))}
          </div>
        </div>
        {bank.by_bank?.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-1.5" data-testid="gstr2-bank-by-bank">
            {bank.by_bank.slice(0, 12).map((b) => (
              <span key={b.name} className="rounded-full border border-amber-200 bg-white px-2.5 py-0.5 text-[11px] text-slate-700">{b.name}: {b.count} · {inrShort(b.total_tax)}</span>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
